import { GUEST_QUOTE_LINK_NOTICE } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { cn } from '@/shared/ui';

interface GuestQuoteLinkNoticeProps {
  /** 놓이는 자리에 맞춘 폭·여백 — 링크 화면(검토 중)과 요청 완료 화면이 넘긴다. */
  readonly className?: string;
}

/**
 * 비회원 견적 링크 공유 안내(사용자 결정 2026-10-16) — 링크를 가진 고객 계정은 누구나 견적을 연결하고 주문할 수 있다.
 * 링크 화면(검토 중·발행됨)과 요청 완료 화면이 같은 모양으로 함께 쓴다. 문구는 `@repo/api-contracts` 의 한 상수이고 worker 메일 꼬리도 같다.
 */
export const GuestQuoteLinkNotice = ({ className }: GuestQuoteLinkNoticeProps): ReactElement => (
  <p
    className={cn(
      'border-l-2 border-brand-lime bg-muted/70 px-3 py-2 text-[13px] leading-relaxed',
      className,
    )}
  >
    {GUEST_QUOTE_LINK_NOTICE}
  </p>
);
